import React from 'react';

export const UpdateProjectDetailsActivityFeedItemDescription = props => <p>
    {props.Event.Activity.User?.name ?? "Unknown user"} {props.GetPhrase()} the {props.CustomEventData ? props.CustomEventData.fieldName : ""}.
</p>;


